<template>
    <seccion-datos :titulo="tipodanyodatos" @cambios="guardar()">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.nombre') }}</label>
                    <input type="text" class="form-control nombre_completo dato" v-model="nombre_tipo_danyo" >
                </div>
            </div>            
        </div>        
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: {
        id: Number,
        
    },
    data() {
        return {
            nombre_tipo_danyo: '',
            tipodanyodatos: "Datos", 
            tipo_danyo: Object
        }
    },
    methods: {
        async cargardatos() {
           if(this.id==0)return;
            this.$store.dispatch('cambiarCargando', true);
            const api = new PwgsApi;
            const datos = await api.get('tipos-dano/' + this.id);
            this.tipo_danyo = datos.datos;
            this.$store.dispatch('cambiarCargando', false);
            this.nombre_tipo_danyo = this.tipo_danyo.danyo;
            
          
        },
        async guardar() {
            /* put  modulos/pwgsapi/index.php/bancos/:id */
            const api = new PwgsApi;
            const datos = { danyo : this.nombre_tipo_danyo };
            if (this.id > 0) {
                try {
                    this.$store.dispatch('cambiarGuardando', true);
                    await api.put('tipos-dano/' + this.id, datos);
                    this.$store.dispatch('cambiarGuardando', false);
                    this.$parent.obtenerTipoDanyo(this.id);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }

                
            }
            else {
                /* post  modulos/pwgsapi/index.php/bancos */
                try {
                    let res;
                    res = await api.post('tipos-dano/', datos);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    this.$router.push('/tiposdanyo/' + res.id);
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        comprobar() { }
    },
    mounted() {
        this.cargardatos();
    }
}
</script>